<h1>
  {{ settings.welcome }}
</h1>

<h2>Authenticating...</h2>

<p>If your application does not load after 30 seconds, please refresh the page.</p>

<mat-progress-spinner color="primary" mode="indeterminate" value="50"> </mat-progress-spinner>
